import React from 'react';
import classnames from 'classnames';

import { abbrNum } from '../../../../utils/helper/common';

type Props = {
  name?: string,
  value?: number,
  maxValue?: number,
  isEmpty?: boolean,
  width?: 'normal' | 'wide'
};

const ChannelTopUsedRow = ({
  name = '-',
  value = 0,
  width = 'normal',
  maxValue = 1,
  isEmpty = true
}: Props) => {
  const percentageStyle = {
    width: `${(value * 100) / maxValue}%`
  };

  const barContainerClasses = classnames({
    'topused-row__bar': true,
    [`topused-row__bar--width-${width}`]: width
  });

  const barClass = classnames({
    'topused-row__bar--selected': true,
    [`topused-row__bar--width-${width}`]: width
  });

  const classNumber = classnames({
    'topused-row__number': true,
    'topused-row__number--disabled': isEmpty,
    [`topused-row__number--width-${width}`]: width
  });

  const classRow = classnames({
    'channel-topused__row': true,
    'channel-topused__hide': isEmpty,
    [`channel-topused__row--width-${width}`]: width
  });

  const nameClasses = classnames({
    'topused-row__name': true,
    'text-overflow-ellipsis': true,
    [`topused-row__name--width-${width}`]: width
  });

  return (
    <div
      className={classRow}
      data-qa="channel-top-used-row"
    >
      <div className={nameClasses}>
        {name}
      </div>
      <div className="topused-row__value">
        <div className={barContainerClasses}>
          <div className={barClass} style={percentageStyle} />
        </div>
        <div className={classNumber}>
          {abbrNum(value, { decimal: 0 })}
        </div>
      </div>
    </div>
  );
};

export default ChannelTopUsedRow;
